import {environment} from '../../../environments/environment';

export interface DoorMessage {
  es: string;
  en: string;
  fr: string;
}

export interface DoorCommand {
  command: string;
  message: DoorMessage;
}

export type DoorCommands = DoorCommand[];

function getMessageByLanguage(doorCommand: DoorCommand, lang: string): string {
  return doorCommand.message[lang as keyof DoorMessage] || doorCommand.message.es;
}

export function getMessage(doorCommand: DoorCommand): string {
  return getMessageByLanguage(doorCommand, environment.defaultAppLang);
}

